"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routePrefix = exports.ServerRoutes = void 0;
var ServerRoutes;
(function (ServerRoutes) {
    ServerRoutes["auth"] = "auth";
    ServerRoutes["admin"] = "admin";
    ServerRoutes["intrested"] = "intrested";
    ServerRoutes["course"] = "course";
    ServerRoutes["webhooks"] = "webhooks";
    ServerRoutes["buyingShit"] = "buying-shit";
    ServerRoutes["store"] = "store";
    ServerRoutes["analytics"] = "analytics";
    ServerRoutes["stylingGroups"] = "styling-groups";
    ServerRoutes["profile"] = "profile";
    ServerRoutes["locales"] = "locales";
    ServerRoutes["staticFiles"] = "static-files";
    ServerRoutes["workshop"] = "workshop";
    ServerRoutes["webinar"] = "webinar";
    ServerRoutes["customLandingPage"] = "customLandingPage";
})(ServerRoutes || (exports.ServerRoutes = ServerRoutes = {}));
exports.routePrefix = "/api/";
